import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';

import Select from '../Select';
import Spinner from '../Spinner';

import { RepMsgs } from '../../services/Messages';
import helper from '../../services/helper';
import { RegistersService } from '../../services/RegistersService';
import { ReportsService } from '../../services/ReportsService';
import ModalEditRegister from '../Registers/ModalEditRegister';
import editBut from '../../imgs/editBut.png';

export default function AcStatements() {
  const accounts = useSelector((state) => state.AccountsReducer.accounts);
  const { defaultAccounts, locale } = useSelector((state) => state.DefaultsReducer);
  const curAccounts = helper.organizedAccounts(accounts, defaultAccounts.currentAccounts);

  const [acId, setAcId] = useState(defaultAccounts?.whereAccounts?.AtSight);
  const initialDate = dayjs(new Date()).startOf('day').toDate();
  initialDate.setDate(initialDate.getDate() - 30);
  const [initDate, setInitDate] = useState(new Date(initialDate));
  const [finalDate, setFinalDate] = useState(new Date());
  const [registers, setRegisters] = useState([]);
  const [lastRegister, setLastRegister] = useState(null);
  const [loading, setLoading] = useState(false);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [registerEditing, setRegisterEditing] = useState(null);

  useEffect(() => {
    if (defaultAccounts?.whereAccounts?.AtSight) {
      setAcId(defaultAccounts?.whereAccounts?.AtSight);
    }
  }, [defaultAccounts]);

  useEffect(() => {
    setLoading(true);
    let mounted = true;
    if (!acId) return;
    // RegistersService.search({
    //   whereAccountId: acId,
    //   emitDate: {
    //     $gte: initDate,
    //     $lt: dayjs(finalDate).endOf('day').toDate(),
    //   },
    // }).then((regs) => {
    //   setLoading(false);
    //   console.log('regs report not used:');
    //     console.log(regs);
    //   // if (mounted) setRegisters(regs);
    // });
    ReportsService.acStatements({
      accountId: acId,
      initDate,
      endDate: dayjs(finalDate).endOf('day').toDate(),
    }).then((result) => {
      if (mounted) {
        console.log('acStatements report:');
        console.log(result);
        setRegisters(result.regs);
        setLastRegister(result.lastRegister || null);
      }
      setLoading(false);
    });
    return () => { mounted = false; };
  }, [acId, initDate, finalDate]);

  function handleDateChange(when, date) {
    switch (when) {
      case 'init':
        setInitDate(helper.inputDateToNewDate(date));
        break;
      case 'final':
        setFinalDate(helper.inputDateToNewDate(date));
        break;
      default:
        break;
    }
  }

  function handleEditClick(reg) {
    setEditModalVisible(true);
    setRegisterEditing({ ...reg, emitDate: dayjs(reg.emitDate) });
  }

  const finalBalance = registers[0]?.whereAccountBalance || lastRegister?.whereAccountBalance || 0;

  return (
    <div>
      {loading && <Spinner />}
      <div><h3>{RepMsgs[locale].statemTitle}</h3></div>
      <div id="form">
        <Select
          value={acId}
          onChange={setAcId}
          options={curAccounts.map((account) => ({
            value: account.id,
            disabled: !account.allowValue,
            label: account.name,
          }))}
        />
        <div>
          {RepMsgs[locale].initial}
          <input
            type="date"
            value={helper.dateToInput(initDate)}
            onChange={(e) => handleDateChange('init', e.target.value)}
          />
        </div>
        <div>
          {RepMsgs[locale].final}
          <input
            type="date"
            value={helper.dateToInput(finalDate)}
            onChange={(e) => handleDateChange('final', e.target.value)}
          />
        </div>
      </div>
      <div id="finalBalance">
        <h3>
          {RepMsgs[locale].balanceP}
          {' '}
          {helper.currencyFormatter(locale, finalBalance)}
        </h3>
      </div>
      <div id="report" className="table-responsive">
        <table className="table big-responsive-table">
          <thead>
            <tr>
              <td>{RepMsgs[locale].date}</td>
              <td>{RepMsgs[locale].thAcc}</td>
              <td>{RepMsgs[locale].value}</td>
              <td>{RepMsgs[locale].balance}</td>
              <td />
            </tr>
          </thead>
          <tbody>
            {registers.map((reg) => {
              const desc = RegistersService.getRegDescToShow(reg);
              const emitDate = helper.formatDate(locale, new Date(reg.emitDate));
              const { value, whereAccountBalance: balance } = reg;
              return (
                <tr key={reg._id} className="register">
                  <td>{emitDate}</td>
                  <td>{desc}</td>
                  <td className={`text-nowrap ${value < 0 ? 'red' : ''}`}>{helper.currencyFormatter(locale, value)}</td>
                  <td className={`text-nowrap ${balance < 0 ? 'red' : ''}`}>
                    {helper.currencyFormatter(locale, balance || 0)}
                  </td>
                  <td><img onClick={() => handleEditClick(reg)} src={editBut} width="10px" alt="editBut" /></td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <ModalEditRegister
          registerInitData={registerEditing}
          editModalVisible={editModalVisible}
          setEditModalVisible={setEditModalVisible}
          registers={registers}
          setRegisters={setRegisters}
        />
      </div>
    </div>
  );
}
